import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  * {
    padding: 0;
    marging: 0;
    border: none;
  }
  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: .4s;
    font-size: 1rem;
    line-height: 1.6;
    font-family: "Work Sans", -apple-system, BlinkMacSystemFont, sans-serif;
    letter-spacing: 0px;
  }

  h1, h2, h3, h4, h5 {
    font-family: "Fraunces", Georgia, serif;
    font-weight: 500;
    letter-spacing: -0.01em;
  }

  textarea,
  button {
    outline: 0px !important;
    -webkit-appearance: none;
    box-shadow: none !important;
  }

  ${({ theme }) =>
    theme.mode === "warm" &&
    `
      .navbar {
        background-color: ${theme.body} !important;
        border-bottom: ${theme.cardBorder};
        box-shadow: none;
      }

      .react-date-picker__inputGroup span,
      .react-date-picker__inputGroup input,
      .react-date-picker__inputGroup__divider,
      .react-datetime-picker__inputGroup span,
      .react-datetime-picker__inputGroup input,
      .react-datetime-picker__inputGroup__divider {
        color: ${theme.accent} !important;
      }
    `}

  @media (prefers-reduced-motion: reduce) {
    * {
      transition: none !important;
      animation: none !important;
    }
  }
`;
